import { reactive } from 'vue'

export const store = reactive({
  account: null,
  session: null,
  userMetadata: null,
  settings: {images: {}, handles: {}, content: {}},
  usdcBalance: null
})
